import publication from '@/api/works/Publication'

export const getMainAuthor = publication =>
  publication.isForeign || publication.commonWork.authors.list[0].isForeignAuthor
    ? publication.commonWork.authors.list[0].getMainAuthorShortNameEng()
    : publication.commonWork.authors.list[0].getMainAuthorShortName()

export const getAuthors = publication =>
  publication.commonWork.authors.list
    .map(el =>
      publication.isForeign || el.isForeignAuthor ? el.getAuthorShortNameReverseEng() : el.getAuthorShortNameReverse()
    )
    .filter(el => el)

export const checkDataCompleteness = (publication, authors) =>
  authors.length &&
  publication.commonWork.workName &&
  (publication.magazine || publication.magazineName) &&
  publication.commonWork.year &&
  (publication.magazineNumber || publication.conferenceMaterial) &&
  ((publication.pageFrom && publication.pageTo) || publication.electronicNumber)

export const getAuthorsPart = (publication, mainAuthor, authors) => {
  const mainAuthorPart = authors.length <= 3 ? `${mainAuthor} ` : ''
  const authorsPart = authors.length > 4 ? `${authors.slice(0, 4).join(', ')} [и др.]` : authors.join(', ')

  return `${mainAuthorPart}${publication.commonWork.workName} / ${authorsPart}`
}

export const getMagazineName = publication => publication.magazine?.name || publication.magazineName

export const getYear = publication => publication.commonWork.year.year

export const getPublicationEngName = publication =>
  publication.isForeign ? ` - ${publication.publicationEngName}` : ''

export const getMagazineNumber = publication =>
  publication.conferenceMaterial ? '' : ' — №' + publication.magazineNumber + '.'

export const getTome = publication =>
  publication.tome && !publication.conferenceMaterial
    ? '— Т. ' + publication.tome + (publication.partNumber ? ', ' : '.')
    : ''
export const getPartNumber = publication =>
  publication.partNumber && publication.tome && !publication.conferenceMaterial
    ? '№ ' + publication.partNumber + '.'
    : ''

export const getPlaceInPublication = publication => getElectronicNumber(publication) || getPages(publication)

export const getElectronicNumber = publication =>
  publication.electronicNumber ? `e${publication.electronicNumber}` : null

export const getPages = publication =>
  `С. ${
    publication.pageFrom === publication.pageTo ? publication.pageFrom : `${publication.pageFrom}-${publication.pageTo}`
  }`

export const getDoi = publication => (publication.doi ? 'DOI:' + publication.doi : '')
